<!-- <ion-spinner *ngIf="drawingGraph"></ion-spinner>
<div class='tooltip'>Tooltip text</div>
<figure id="bar"></figure> -->

<div class="container">
    <div class="button-container">
        <ion-button (click)="zoomIn()" fill="clear" size="small" class="zoom-button">
            <ion-icon name="add-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="zoomOut()" fill="clear" size="small" class="zoom-button">
            <ion-icon name="remove-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="reset()" fill="clear" size="small" class="zoom-button">
            <ion-icon name="refresh-outline"></ion-icon>
        </ion-button>
    </div>
    <figure id="bar">
        <div class="tooltip">
            Tooltip text
        </div>
    </figure>
  </div> 